export var SurveyStep;
(function (SurveyStep) {
    SurveyStep[SurveyStep["Start"] = 0] = "Start";
    SurveyStep[SurveyStep["Response"] = 1] = "Response";
    SurveyStep[SurveyStep["Final"] = 2] = "Final";
})(SurveyStep || (SurveyStep = {}));
export var ConnectionLevel;
(function (ConnectionLevel) {
    ConnectionLevel["Excellent"] = "excellent";
    ConnectionLevel["Fair"] = "fair";
    ConnectionLevel["Unstable"] = "unstable";
    ConnectionLevel["Poor"] = "poor";
    ConnectionLevel["Disconnected"] = "disconnected";
})(ConnectionLevel || (ConnectionLevel = {}));
export const CONNECTION_LEVELS_TO_SHOW_PARTICIPANT_NPI = [
    ConnectionLevel.Poor,
    ConnectionLevel.Unstable,
];
export var SurveyTab;
(function (SurveyTab) {
    SurveyTab["Video"] = "video";
    SurveyTab["Audio"] = "audio";
    SurveyTab["Features"] = "features";
    SurveyTab["Other"] = "other";
})(SurveyTab || (SurveyTab = {}));
/**
 * Controls the display size of video frames of the participants. There are three types of frame sizes:
 * -- large
 * -- medium
 * -- small
 * The larger the number of participants, the smaller the frame size.
 */
export const PARTICIPANTS_MIN_COUNT_FOR_MEDIUM_FRAMES = 3;
export const PARTICIPANTS_MAX_COUNT_FOR_MEDIUM_FRAMES = 6;
export var StreamType;
(function (StreamType) {
    StreamType["Screen"] = "screen";
    StreamType["Camera"] = "camera";
    StreamType["Spectator"] = "spectator";
})(StreamType || (StreamType = {}));
export var CallFrameVariant;
(function (CallFrameVariant) {
    CallFrameVariant["Full"] = "full";
    CallFrameVariant["Mini"] = "mini";
})(CallFrameVariant || (CallFrameVariant = {}));
export var SelfPublisherErrorType;
(function (SelfPublisherErrorType) {
    SelfPublisherErrorType["NoDevices"] = "NoDevices";
    SelfPublisherErrorType["DestroyPublisher"] = "DestroyPublisher";
    SelfPublisherErrorType["GetUserVideo"] = "GetUserVideo";
    SelfPublisherErrorType["GetUserAudio"] = "GetUserAudio";
    SelfPublisherErrorType["NoAudioAndVideoAccess"] = "NoAudioAndVideoAccess";
    SelfPublisherErrorType["OTInitPublisher"] = "OTInitPublisher";
})(SelfPublisherErrorType || (SelfPublisherErrorType = {}));
export var VideoQuality;
(function (VideoQuality) {
    VideoQuality["Low"] = "ld";
    VideoQuality["Medium"] = "sd";
    VideoQuality["High"] = "hd";
})(VideoQuality || (VideoQuality = {}));
